import { Cascader, CascaderAutoProps } from "antd";
import styles from "./index.module.css";
import { CascaderRef } from "antd/es/cascader";
import { highlightText } from "helpers/helper";
import CaretRight from "assets/svg/CaretRightGray.svg";
import SquaresFour from "assets/svg/SquaresFour.svg";

const SIZE_OF_CAT = 42;
export const CustomCascader = (
  props: React.PropsWithChildren<CascaderAutoProps<any>> & React.RefAttributes<CascaderRef>,
) => {
  return (
    <Cascader
      {...props}
      displayRender={props.displayRender ? props.displayRender : (label) => label.join(", ")}
      allowClear={false}
      size="large"
      open={props.open}
      suffixIcon={<img src={SquaresFour} alt="squares" />}
      showSearch={
        props.showSearch
          ? props.showSearch
          : {
              render: (v, path) => {
                const mainHeight = path.length * SIZE_OF_CAT;
                const isBigger = window.innerHeight < mainHeight;

                return (
                  <div
                    style={{
                      display: "flex",
                      height: isBigger ? `${window.innerHeight}px` : "auto",
                    }}
                  >
                    {path.map((opt, i) => (
                      <div key={opt.value + opt.label.toString()} className={styles.searchOpt}>
                        <span>{highlightText(opt.label.toString(), v, styles.searchWord)}</span>
                        {i !== path.length - 1 && (
                          <img src={CaretRight} alt="rightIcon" className={styles.arrowSpacingSearch} />
                        )}
                      </div>
                    ))}
                  </div>
                );
              },
            }
      }
      expandIcon={
        props.expandIcon ? props.expandIcon : <img src={CaretRight} alt="rightIcon" className={styles.arrowSpacing} />
      }
      getPopupContainer={
        props.getPopupContainer
          ? props.getPopupContainer
          : (props) => {
              if (!props?.querySelectorAll) return props;
              const menus = props.querySelectorAll(".ant-cascader-menu");
              if (!menus.length) return props;
              menus.forEach((v) => {
                v.style.overflow = "auto";
                const sizeOfList = v.querySelectorAll("li").length;
                const mainHeight = sizeOfList * SIZE_OF_CAT;

                const list = v.querySelectorAll("li")[0];
                const isEmpty = list.getAttribute("data-path-key") === "__EMPTY__";

                if (isEmpty) {
                  v.style.height = `100px`;
                  return;
                }
                if (window.innerHeight < mainHeight) {
                  v.style.height = `${window.innerHeight}px`;
                } else {
                  v.style.height = `${mainHeight}px`;
                }
              });
              return props;
            }
      }
      className={props?.className ? props.className + " " + styles.cascader : styles.cascader}
      classNames={{
        popup: {
          root: props?.classNames?.popup?.root ? props?.classNames?.popup?.root : styles.popup,
        },
      }}
    />
  );
};
